import { formatToCommaWithLang, toCommaOptions } from '@slot-nx/core'

export const formatNumberWithComma = (num: number, option = toCommaOptions.maximumTwoDecimalPlaces): string => {
  return formatToCommaWithLang(num, navigator.language, option)
}

export const changeFontSize = (text: string): number => {
  if (text.length > 9) {
    return 30
  }
  if (text.length > 7) {
    return 35
  }
  return 40
}
